
export const setCurrentProjectData = (state, currentProjectData) => {
    state.currentProjectData = currentProjectData;
}

export const setOriginalProjectData = (state, originalProjectData) => {
    state.originalProjectData = originalProjectData;
}
